import { createCallbacks } from "@microsoft/shifts-experiences-shared";

import { SmartSchedulingCallbacks } from "./SmartSchedulingCallbacks";

const { CallbacksProvider, useCallbacks } = createCallbacks<SmartSchedulingCallbacks>();

export { CallbacksProvider, useCallbacks };